import './Main.css';
import { isWidgetSdkEmbed } from '../../lib/util';

interface MainProps {
  children?: JSX.Element[] | JSX.Element;
  footer?: JSX.Element;
  className: string;
}

function Main({ children, footer, className }: MainProps): JSX.Element {
  // The overlay supplies its own cancel button. See https://github.com/vippsas/ecom-elements/blob/main/widget-sdk/overlay.ts
  if (isWidgetSdkEmbed()) {
    return (
      <main className={`main ${className}`} aria-live="polite">
        {children}
      </main>
    );
  }

  return (
    <div className={`parent ${className}`}>
      <main className="main" aria-live="polite">
        {children}
      </main>
      {footer}
    </div>
  );
}

export default Main;
